// extracted by mini-css-extract-plugin
export var fulfillmentFooter = "_redotech-redo-web-src-settings-elements-order-order-fulfillment-footer";
export var product = "_redotech-redo-web-src-settings-elements-order-order-product";
export var productImage = "_redotech-redo-web-src-settings-elements-order-order-product-image";
export var productTitle = "_redotech-redo-web-src-settings-elements-order-order-product-title";